// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  background: #ed143d;
  color: white;
  padding: 8px;
  font-size: 16px;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: start;
  justify-content: center;
  gap: 5px;
}
.error-container p {
  margin: 0;
}
.error-container ion-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.weekdays-container {
  display: flex;
  gap: 5px;
  flex: 1;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.weekdays-container ion-badge {
  background: none;
  color: #333;
  border: 1px solid #333;
  padding: 5px 6px;
}
.weekdays-container ion-badge.selected {
  background: #ed143d;
  color: white;
  border: 1px solid #ed143d;
}

.recurrence-end {
  display: flex;
  align-items: center;
}
.recurrence-end span {
  font-weight: 600;
  flex: 0.75;
  color: #888;
  margin: 0;
  font-size: 15px;
  padding: 0;
}
.recurrence-end ion-chip {
  display: flex;
  justify-content: space-between;
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
  flex: 1;
}

.container {
  margin: 5px;
  border-radius: 8px;
  padding: 0 15px 50px 15px;
}
.container .time-container {
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background: #efefef;
  padding: 5px 10px;
  border-radius: 8px;
  margin-block: 10px 20px;
  gap: 2px;
}
.container .time-container .meeting-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container .time-container .meeting-time .start-end-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.container .time-container .meeting-time .start-end-container div {
  display: flex;
  align-items: center;
}
.container .time-container .meeting-time .start-end-container div span {
  font-weight: 600;
  flex: 0.5;
  font-size: 15px;
  color: #888;
  margin: 0;
  padding: 0;
}
.container .time-container .meeting-time .start-end-container div ion-chip {
  display: flex;
  justify-content: center;
  border-radius: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.container .time-container .meeting-time .start-end-container div ion-chip.date-chip {
  margin-left: auto;
}
.container .time-container .meeting-time .start-end-container div ion-chip ion-icon {
  color: #ed143d;
}
.container .time-container .meeting-time .all-day {
  margin: 4px;
  margin-left: 0px;
}
.container .time-container .duration {
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;
}
.container .time-container .duration span {
  display: flex;
  font-size: 15px;
  align-items: center;
  font-weight: 600;
  color: #888;
  gap: 5px;
}
.container .time-container .duration span ion-icon {
  color: #ed143d;
  font-size: 18px;
}
.container .time-container .duration ion-chip {
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

ion-toggle {
  font-weight: 600;
  display: block;
  margin: 0 auto;
  --track-background-checked: #ed143d;
  width: 100%;
}

ion-datetime {
  --ion-color-primary: #ed143d;
  box-shadow: none;
  padding-top: 8px;
}

ion-datetime::part(calendar-day):focus {
  box-shadow: none;
}

ion-datetime::part(time-button) {
  background: #fff9f9;
  border: 2px solid #ed143d;
  font-weight: 600;
}

ion-datetime.disabled-time::part(time-button) {
  pointer-events: none;
  opacity: 0.3;
}

ion-datetime::part(month-year-button) {
  color: #ed143d;
  padding-block: 0;
  transform: translateY(-8px);
}

ion-popover.datetime-popover::part(content) {
  --width: 350px;
  --max-width: 90%;
  --height: auto;
}

ion-select::part(label) {
  color: #888;
  font-size: 17px;
}

ion-select::part(container) {
  font-size: 15px;
}

ion-select::part(icon) {
  color: #ed143d;
  transform: translateY(10px);
}

ion-select ion-icon {
  color: #ed143d;
  font-size: 20px;
  margin-right: 10px;
}

ion-popover.duration-popover {
  --offset-y: -200px;
}

.subject-input {
  font-weight: 600;
  padding: 10px 0 !important;
  margin: 10px;
  font-size: 21px;
}

ion-input::ng-deep .input-clear-icon {
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/event/event.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,8CAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;AACF;AAAE;EACE,SAAA;AAEJ;AAAE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAEJ;;AACA;EACE,aAAA;EACA,QAAA;EACA,OAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AAEF;AADE;EACE,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AAGJ;AAFI;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AAIN;;AAAA;EACE,aAAA;EACA,mBAAA;AAGF;AAFE;EACE,gBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AAIJ;AAFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,OAAA;AAIJ;;AADA;EAEE,WAAA;EACA,kBAAA;EACA,yBAAA;AAGF;AADE;EACE,aAAA;EACA,sBAAA;EACA,wCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;AAGJ;AAFI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAIN;AAFM;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AAIR;AAHQ;EACE,aAAA;EACA,mBAAA;AAKV;AAJU;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAMZ;AAJU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAMZ;AALY;EAEE,iBAAA;AAMd;AAJY;EACE,cAAA;AAMd;AADM;EACE,WAAA;EACA,gBAAA;AAGR;AAAI;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AACN;AACM;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;AACR;AAAQ;EACE,cAAA;EACA,eAAA;AAEV;AACM;EAGE,mBAAA;EACA,gBAAA;EACA,qBAAA;AADR;;AAQA;EACE,gBAAA;EACA,cAAA;EACA,cAAA;EACA,mCAAA;EACA,WAAA;AALF;;AAQA;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,YAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;EACA,2BAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,WAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,cAAA;EACA,2BAAA;AALF;;AAUE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAPJ;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;AAPF;;AAUA;EACE,oBAAA;AAPF","sourcesContent":[".error-container {\n  background: #ed143d;\n  color: white;\n  padding: 8px;\n  font-size: 16px;\n  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  gap: 5px;\n  p {\n    margin: 0;\n  }\n  ion-icon {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n  }\n}\n.weekdays-container {\n  display: flex;\n  gap: 5px;\n  flex: 1;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  ion-badge {\n    background: none;\n    color: #333;\n    border: 1px solid #333;\n    padding: 5px 6px;\n    &.selected {\n      background: #ed143d;\n      color: white;\n      border: 1px solid #ed143d;\n    }\n  }\n}\n.recurrence-end {\n  display: flex;\n  align-items: center;\n  span {\n    font-weight: 600;\n    flex: 0.75;\n    color: #888;\n    margin: 0;\n    font-size: 15px;\n    padding: 0;\n  }\n  ion-chip {\n    display: flex;\n    justify-content: space-between;\n    border-radius: 12px;\n    font-weight: 700;\n    letter-spacing: 1.2px;\n    flex: 1;\n  }\n}\n.container {\n  // height:100%;\n  margin: 5px;\n  border-radius: 8px;\n  padding: 0 15px 50px 15px;\n\n  .time-container {\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    background: #efefef;\n    padding: 5px 10px;\n    border-radius: 8px;\n    margin-block: 10px 20px;\n    gap: 2px;\n    .meeting-time {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .start-end-container {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        div {\n          display: flex;\n          align-items: center;\n          span {\n            font-weight: 600;\n            flex: 0.5;\n            font-size: 15px;\n            color: #888;\n            margin: 0;\n            padding: 0;\n          }\n          ion-chip {\n            display: flex;\n            justify-content: center;\n            border-radius: 12px;\n            font-weight: 700;\n            white-space: nowrap;\n            &.date-chip {\n              // flex: 1;\n              margin-left: auto;\n            }\n            ion-icon {\n              color: #ed143d;\n            }\n          }\n        }\n      }\n      .all-day {\n        margin: 4px;\n        margin-left: 0px;\n      }\n    }\n    .duration {\n      // margin: 5px 0;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      position: relative;\n\n      span {\n        display: flex;\n        font-size: 15px;\n        align-items: center;\n        font-weight: 600;\n        color: #888;\n        gap: 5px;\n        ion-icon {\n          color: #ed143d;\n          font-size: 18px;\n        }\n      }\n      ion-chip {\n        // display: flex;\n        // justify-content: space-between;\n        border-radius: 12px;\n        font-weight: 700;\n        letter-spacing: 1.2px;\n        // flex: 1;\n      }\n    }\n  }\n}\n\nion-toggle {\n  font-weight: 600;\n  display: block;\n  margin: 0 auto;\n  --track-background-checked: #ed143d;\n  width: 100%;\n}\n\nion-datetime {\n  --ion-color-primary: #ed143d;\n  box-shadow: none;\n  padding-top: 8px;\n}\n\nion-datetime::part(calendar-day):focus {\n  box-shadow: none;\n}\n\nion-datetime::part(time-button) {\n  background: #fff9f9;\n  border: 2px solid #ed143d;\n  font-weight: 600;\n}\n\nion-datetime.disabled-time::part(time-button) {\n  pointer-events: none;\n  opacity: 0.3;\n}\n\nion-datetime::part(month-year-button) {\n  color: #ed143d;\n  padding-block: 0;\n  transform: translateY(-8px);\n}\n\nion-popover.datetime-popover::part(content) {\n  --width: 350px;\n  --max-width: 90%;\n  --height: auto;\n}\n\nion-select::part(label) {\n  color: #888;\n  font-size: 17px;\n}\n\nion-select::part(container) {\n  font-size: 15px;\n}\n\nion-select::part(icon) {\n  color: #ed143d;\n  transform: translateY(10px);\n}\n\nion-select {\n  // transform: translateY(-4px);\n  ion-icon {\n    color: #ed143d;\n    font-size: 20px;\n    margin-right: 10px;\n  }\n}\nion-popover.duration-popover {\n  --offset-y: -200px;\n}\n\n.subject-input {\n  font-weight: 600;\n  padding: 10px 0 !important;\n  margin: 10px;\n  font-size: 21px;\n}\n\nion-input::ng-deep .input-clear-icon {\n  justify-content: end;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
